/** @jsx jsx */
import { React, expressionUtils, css, polished, jsx } from 'jimu-core';
import { Button, TextInput, defaultMessages, Popper, Label, Switch, NumericInput, Checkbox } from 'jimu-ui';
import { SettingOutlined } from 'jimu-icons/outlined/application/setting';
import ExpressionEditor from '../../expression-editor';
import { getTheme, getTheme2 } from 'jimu-theme';
const DefaultNumberFormat = {
    useGrouping: true,
    notation: 'standard',
    minimumFractionDigits: 0,
    maximumFractionDigits: 4
};
class ExpressionTab extends React.PureComponent {
    constructor(props) {
        var _a, _b, _c, _d, _e, _f;
        super(props);
        this.numberFormatBtnRef = React.createRef();
        this.expressionCountAdded = false;
        this.insertCount = 0;
        this.theme = window.jimuConfig.isBuilder ? getTheme() : getTheme2();
        this.numberFormatStyles = css `
    width: ${polished.rem(240)};
    padding: ${polished.rem(16)};
    .number-format-switch-label{
      font-size: ${polished.rem(14)};
      font-weight: 600;
      color: ${((_a = this.theme) === null || _a === void 0 ? void 0 : _a.ref.palette.neutral[1100]) || '#dcdcdc'};
    }
    .number-format-checkbox-label{
      font-size: ${polished.rem(13)};
      color: ${((_b = this.theme) === null || _b === void 0 ? void 0 : _b.ref.palette.neutral[1100]) || '#dcdcdc'};
    }
    .number-format-numeric-input-label{
      font-size: ${polished.rem(13)};
      color: ${((_c = this.theme) === null || _c === void 0 ? void 0 : _c.ref.palette.neutral[900]) || '#a0a0a0'};
    }
  `;
        this.getMutableExpression = (expression) => {
            const e = this.props.expression && this.props.expression.asMutable
                ? this.props.expression.asMutable({ deep: true })
                : this.props.expression;
            return e;
        };
        this.onExpChange = (e) => {
            this.setState({ expression: e });
        };
        this.onChange = () => {
            const newExpression = { name: this.state.name || this.getDefaultName(), parts: this.state.expression && this.state.expression.parts };
            if (this.state.numberFormat) {
                newExpression.numberFormat = this.state.numberFormat;
            }
            this.insertCount++;
            this.props.onChange(newExpression);
        };
        this.onNameChange = e => {
            this.setState({ name: e.target.value });
        };
        this.getDefaultName = () => {
            return `${this.props.intl.formatMessage({ id: 'expression', defaultMessage: defaultMessages.expression })} ${ExpressionTab.count}`;
        };
        this.getWhetherDisableInsert = () => {
            return !this.state.expression || !this.state.expression.parts || this.state.expression.parts.length === 0 || !expressionUtils.getWhetherExpressionValid(this.state.expression);
        };
        this.onNumberFormatClick = () => {
            this.toggleNumberFormatSettingPopper();
        };
        this.toggleNumberFormatSettingPopper = () => {
            this.setState({ isNumberFormatSettingOpen: !this.state.isNumberFormatSettingOpen });
        };
        this.onToggleNumberFormatSetting = (e, checked) => {
            if (checked) {
                this.setState({ numberFormat: DefaultNumberFormat });
            }
            else {
                this.setState({ numberFormat: null });
            }
        };
        this.onMinDigitsChange = (v) => {
            this.setState({ numberFormat: Object.assign(Object.assign({}, this.state.numberFormat), { minimumFractionDigits: v }) });
        };
        this.onMaxDigitsChange = (v) => {
            this.setState({ numberFormat: Object.assign(Object.assign({}, this.state.numberFormat), { maximumFractionDigits: v }) });
        };
        this.onUseGroupChange = (e, checked) => {
            this.setState({ numberFormat: Object.assign(Object.assign({}, this.state.numberFormat), { useGrouping: checked }) });
        };
        this.onNotationChange = (e, checked) => {
            this.setState({ numberFormat: Object.assign(Object.assign({}, this.state.numberFormat), { notation: checked ? 'compact' : 'standard' }) });
        };
        if (!((_d = props.expression) === null || _d === void 0 ? void 0 : _d.name)) {
            // index in default expression name need to plus one
            ExpressionTab.count++;
            this.expressionCountAdded = true;
        }
        this.state = {
            expression: this.getMutableExpression(this.props.expression),
            name: ((_e = this.props.expression) === null || _e === void 0 ? void 0 : _e.name) || this.getDefaultName(),
            numberFormat: (_f = this.props.expression) === null || _f === void 0 ? void 0 : _f.numberFormat,
            isNumberFormatSettingOpen: false
        };
    }
    componentDidUpdate(prevProps) {
        var _a, _b;
        if (prevProps.expression !== this.props.expression) {
            this.setState({
                expression: this.getMutableExpression(this.props.expression),
                name: ((_a = this.props.expression) === null || _a === void 0 ? void 0 : _a.name) || this.getDefaultName(),
                numberFormat: (_b = this.props.expression) === null || _b === void 0 ? void 0 : _b.numberFormat
            });
        }
    }
    componentWillUnmount() {
        // didn't insert any expression, reset the index of default expression name
        if (this.expressionCountAdded && this.insertCount === 0) {
            ExpressionTab.count--;
        }
    }
    render() {
        var _a, _b;
        const numberFormatString = this.props.intl.formatMessage({ id: 'numberFormatting', defaultMessage: defaultMessages.numberFormatting });
        const decimalPlaceString = this.props.intl.formatMessage({ id: 'decimalPlace', defaultMessage: defaultMessages.decimalPlace });
        const showThousandSeparatorString = this.props.intl.formatMessage({ id: 'showThousandSeparator', defaultMessage: defaultMessages.showThousandSeparator });
        const unitString = this.props.intl.formatMessage({ id: 'unit', defaultMessage: defaultMessages.unit });
        const toString = this.props.intl.formatMessage({ id: 'to', defaultMessage: defaultMessages.to });
        const numberFormatDecimalId = `expression-${ExpressionTab.count}-number-format-decimal`;
        return (jsx("div", { className: 'expression-builder-tab expression-tab px-4' },
            jsx("div", { className: 'mb-4' },
                jsx("div", { className: 'd-flex justify-content-start' },
                    jsx(TextInput, { className: 'flex-grow-1', value: this.state.name, onChange: this.onNameChange, id: 'expression-name-input', size: 'sm' }))),
            jsx("div", { className: 'expression-editor-container' },
                jsx(ExpressionEditor, Object.assign({}, this.props, { expression: this.state.expression, onChange: this.onExpChange, autoFocus: this.props.isActive }))),
            jsx("div", { className: 'fixed-at-bottom d-flex align-items-center justify-content-between px-4' },
                jsx(Button, { type: 'default', icon: true, size: 'default', onClick: this.onNumberFormatClick, title: numberFormatString, "aria-label": numberFormatString, ref: this.numberFormatBtnRef },
                    jsx(SettingOutlined, { size: 'm' })),
                jsx(Button, { onClick: this.onChange, type: 'primary', disabled: this.getWhetherDisableInsert(), className: 'expression-insert-btn ml-2', size: 'default', title: this.props.intl.formatMessage({ id: 'insert', defaultMessage: defaultMessages.insert }) },
                    jsx("div", { className: 'text-truncate' }, this.props.intl.formatMessage({ id: 'insert', defaultMessage: defaultMessages.insert })))),
            jsx(Popper, { reference: this.numberFormatBtnRef.current, open: this.state.isNumberFormatSettingOpen, arrowOptions: true, toggle: this.toggleNumberFormatSettingPopper, offsetOptions: [-8, 0], placement: 'top-start', autoUpdate: true },
                jsx("div", { css: this.numberFormatStyles },
                    jsx("div", { className: 'w-100 mb-2' },
                        jsx(Label, { className: 'w-100 d-flex justify-content-between' },
                            jsx("div", { className: 'w-75 text-truncate number-format-switch-label', title: numberFormatString }, numberFormatString),
                            jsx(Switch, { checked: !!this.state.numberFormat, onChange: this.onToggleNumberFormatSetting }))),
                    this.state.numberFormat &&
                        jsx("div", { className: 'w-100' },
                            jsx("div", { className: 'w-100 mb-2 d-flex' },
                                jsx(Label, { className: 'w-100 text-truncate m-0 number-format-numeric-input-label', for: numberFormatDecimalId }, decimalPlaceString)),
                            jsx("div", { className: 'w-100 d-flex justify-content-between mb-4', id: numberFormatDecimalId },
                                jsx(NumericInput, { value: this.state.numberFormat.minimumFractionDigits, onChange: this.onMinDigitsChange, showHandlers: true, precision: 0, min: 0, max: (_a = this.state.numberFormat.maximumFractionDigits) !== null && _a !== void 0 ? _a : 20, size: 'sm' }),
                                jsx("span", { className: 'mx-2 number-format-numeric-input-label' }, toString),
                                jsx(NumericInput, { value: this.state.numberFormat.maximumFractionDigits, onChange: this.onMaxDigitsChange, showHandlers: true, precision: 0, min: (_b = this.state.numberFormat.minimumFractionDigits) !== null && _b !== void 0 ? _b : 0, max: 20, size: 'sm' })),
                            jsx("div", { className: 'w-100 mb-2' },
                                jsx(Label, { className: 'w-100 d-flex justify-content-start m-0' },
                                    jsx(Checkbox, { className: 'mr-2', checked: !!this.state.numberFormat.useGrouping, onChange: this.onUseGroupChange }),
                                    jsx("div", { className: 'w-85 text-truncate number-format-checkbox-label', title: showThousandSeparatorString }, showThousandSeparatorString))),
                            jsx("div", { className: 'w-100' },
                                jsx(Label, { className: 'w-100 d-flex justify-content-start m-0' },
                                    jsx(Checkbox, { className: 'mr-2', checked: this.state.numberFormat.notation === 'compact', onChange: this.onNotationChange }),
                                    jsx("div", { className: 'w-85 text-truncate number-format-checkbox-label', title: unitString }, unitString))))))));
    }
}
ExpressionTab.count = 0;
export default ExpressionTab;
